import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb'
import { tva } from '@gluestack-ui/nativewind-utils/tva'

const baseStyle = isWeb
  ? 'tracking-sm my-0 bg-transparent border-0 box-border display-inline list-none margin-0 padding-0 position-relative text-start no-underline whitespace-pre-wrap word-wrap-break-word'
  : ''

export const textStyle = tva({
  base: `font-poppinsRegular text-typography-700 ${baseStyle}`,

  variants: {
    isTruncated: {
      true: 'web:truncate'
    },
    bold: {
      true: 'font-poppinsBold'
    },
    underline: {
      true: 'underline'
    },
    strikeThrough: {
      true: 'line-through'
    },
    size: {
      '2xs': 'text-2xs',
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl'
    },
    sub: {
      true: 'text-xs'
    },
    italic: {
      true: 'italic'
    },
    highlight: {
      true: 'bg-yellow-500'
    }
  }
})
